import { Injectable } from "@angular/core";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  getFirestore,
  orderBy,
  query,
} from "firebase/firestore";
import {
  getFunctions,
  httpsCallable,
  connectFunctionsEmulator,
} from "firebase/functions";
import { environment } from "src/environments/environment";
@Injectable({
  providedIn: "root",
})
export class PayService {
  functions = getFunctions();
  constructor() {
    if (!environment.production) {
      // Use this only in development
      // connectFunctionsEmulator(this.functions, "localhost", 5001);
    }
  }

  async cancelSubscription(
    subscriptionId: string,
    userId: string,
    creatorId: string
  ): Promise<any> {
    try {
      const cancel = httpsCallable(this.functions, "cancelSubscription");
      const result: any = await cancel({ subscriptionId, userId, creatorId });
      console.log("Cancel Subscription Response:", result.data);
      return result.data;
    } catch (error) {
      console.error("Error canceling subscription:", error);
      throw error;
    }
  }

  async createCreatorSubscription(data: {
    userId: string;
    planName: string;
    priceId: string;
    billingCycle: "monthly" | "yearly";
  }): Promise<{ sessionId?: string; success?: boolean; planName?: string }> {
    try {
      const createSession = httpsCallable(
        this.functions,
        "createCreatorSubscriptionSession"
      );
      const result: any = await createSession(data);
      return result.data;
    } catch (error) {
      console.error("Error creating creator subscription session:", error);
      throw error; // Re-throw to be handled by the component
    }
  }

  async getCreatorPlans(): Promise<any[]> {
    const db = getFirestore();
    const plansCol = collection(db, "creatorOptions");
    // The 'rank' field is used to order the plans correctly.
    const q = query(plansCol, orderBy("rank", "asc"));
    const plansSnapshot = await getDocs(q);
    if (plansSnapshot.empty) {
      console.warn("No creator plans found in 'creatorOptions' collection.");
      return [];
    }
    return plansSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  }

  async getArtists(artistId: string): Promise<any | null> {
    const db = getFirestore(); // Initialize Firestore
    const userRef = doc(getFirestore(), "users", artistId); // Reference to the user's document

    try {
      const userDoc = await getDoc(userRef); // Fetch the document
      if (userDoc.exists()) {
        const userData = userDoc.data();
        const displayName = userData.displayName || null; // Get the displayName field
        const photo = userData.bannerPhoto || null; // Get the BannerPhoto field
        return { displayName, photo }; // Return the displayName field or null if not found
      } else {
        console.error("No such user document!");
        return null;
      }
    } catch (error) {
      console.error("Error fetching artist:", error);
      return null;
    }
  }

  async pay(product) {
    try {
      const pay = httpsCallable(this.functions, "createCheckoutSession");
      console.log(product);
      const result: any = await pay(product);
      console.log("Subscription Response:", result.data);
      return result.data;
    } catch (error) {
      console.error("Error creating subscription:", error);
    }
  }
}
